export default function UnselectProduct(state, payload){
  const {product} = payload;
  delete state.selectedProducts[product.id]
  return {...state}
}